'use client';

import type { Listing } from '@ps/models/lib/listing';

import { useVariantQuantity } from '../contexts/variant-quantity/context';
import { ProductPrice } from './ProductPrice';

type VariantAwarePriceProps = {
  listing: Pick<
    Listing,
    | 'price'
    | 'discountPrice'
    | 'discountEnabled'
    | 'discountStartDate'
    | 'discountEndDate'
  >;
  isTicket?: boolean;
  className?: string;
};

/**
 * `ProductPrice` wired to the variant/quantity context — reflects the
 * selected variant's price. Falls back to the listing price outside the
 * provider (digital/external listings that don't mount `PdpInteractive`).
 * Coupon-preview discounting is handled inside `ProductPrice` itself.
 */
export function VariantAwarePrice(props: VariantAwarePriceProps) {
  const ctx = useVariantQuantity();
  return <ProductPrice {...props} variant={ctx?.selectedVariant} />;
}
